<template>
    <div
        v-if="visibleModal === modalName"
        :class="isLoading ? 'bg-opacity-75 backdrop-blur-xs' : 'bg-opacity-25'"
        class="fixed top-0 z-20 flex h-screen w-screen bg-black outline-none"
        tabindex="0"
        @keyup.enter.stop="validate()"
        @keyup.stop="cancel($event)"
    >
        <!-- Loader-->
        <div
            v-if="isLoading"
            class="absolute inset-1/2 z-40 -ml-5"
        >
            <MyLoader
                :class="classStyles['text-main_color-600']"
                size-icon="lg"
            ></MyLoader>
        </div>

        <div
            v-click-outside="closeModal"
            :class="[
                styles.card,
                { 'animate__animated animate__fadeInDown' : anim },
                { 'blur-xs': isLoading }
              ]"
            class="m-auto w-11/12 max-w-md md:w-2/3 xl:w-1/2"
        >
            <h2 class="mb-2">{{ title }}</h2>
            <div
                :class="classStyles['divide-main_color-700']"
                class="divide-y-4 divide-double"
            >
                <div class="my-2 text-gray-800">
                    <span v-if="description !== undefined">{{ description }}</span>
                </div>
                <div
                    v-if="!!this.$slots.default"
                    class="xs:flex-row-reverse xs:justify-center mt-2 flex flex-col pt-2"
                >
                    <slot/>
                </div>
                <div class="xs:flex-row-reverse mt-2 flex flex-col items-center pt-2">
                    <div
                        class="xs:mb-0 mx-auto mb-2"
                        @click.stop="validate()"
                    >
                        <slot name="validate"></slot>
                    </div>
                    <div
                        class="mx-auto"
                        @click="closeModal()"
                    >
                        <BaseButtonSimple color-type="secondary">{{ cancelText }}</BaseButtonSimple>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapWritableState } from 'pinia'

import useGenericStore from '../../common/store/generic'
import MyLoader from '../MyLoader'
import BaseButtonSimple from './Buttons/BaseButtonSimple'

export default {
  name: 'BaseModalSmall',
  components: {
    BaseButtonSimple,
    MyLoader
  },
  props: {
    title: {
      type: String,
      default: 'Les informations seront perdues'
    },

    description: {
      type: String
    },

    modalName: {
      type: String,
      required: true
    },

    cancelText: {
      type: String,
      default: 'Annuler'
    },

    confirmActionReturn: String
  },

  data () {
    return {
      styles: window.myStyles,
      anim: window.anim,
      classStyles: window.class_styles,
      isLoading: false
    }
  },

  methods: {
    validate () {
      this.isLoading = true
      const confirmAction = this.$listeners['confirm-action']
      if (this.confirmActionReturn === 'promise') {
        confirmAction().then(this.hideModal, _ => {
          this.isLoading = false
        })
      } else if (this.confirmActionReturn !== 'redirect') {
        confirmAction()
        this.hideModal()
      } else confirmAction()
    },

    cancel (e) {
      switch (e.key) {
        case 'Escape':
        case 'Backspace':
        case 'ArrowLeft':
          this.closeModal()
      }
    },

    closeModal () {
      this.isLoading = true
      if (this.$listeners && typeof this.$listeners.cancel === 'function') {
        if (this.$listeners.cancel() !== 'isRedirection') this.hideModal()
      } else this.hideModal()
    },

    hideModal () {
      this.visibleModal = null
      this.$root.focusStep()
      this.isLoading = false
    }
  },

  computed: {
    ...mapWritableState(useGenericStore, ['visibleModal'])
  },

  watch: {
    visibleModal (newVal) {
      if (newVal === this.modalName) this.$nextTick(_ => this.$el.focus())
    }
  }
}
</script>

<style scoped>

</style>
